import { ComponentsManager, Component, EventBus } from '../core/smpl-components.js'
import { AnchorScroller } from '../modules/anchor-scroller.js'
import PinnedLayers from '../modules/pinned-layers.js'
import { gsap } from 'gsap'

class LanguageSelect {
	constructor(element) {
		this.element = element
		console.log(this.element)
		this.elToggle = this.element.querySelector('.language-select__toggle')
		this.elOptions = this.element.querySelector('.language-select__list')
		this.elOptionsWrapper = this.element.querySelector('.language-select__options')

		this.isOpen = false

		this.handleToggleClick = this.handleToggleClick.bind(this)

		this.init()
	}
	handleToggleClick() {
		console.log('toggle click')

		if (this.isOpen) {
			this.collapseSelect()
		} else {
			this.expandSelect()
		}

		// this.elOptionsWrapper.style.height = this.isOpen ? `${this.elOptions.scrollHeight}px` : '0'

		// language-select__options has max-width:0 and overflow clip. It should resize to the width of this.elOptions when open, and back to 0 when closed. We can achieve this by setting the width to the scrollWidth of this.elOptions when open, and back to 0 when closed.

		// this.elOptionsWrapper.style.width = this.isOpen ? `${this.elOptions.scrollWidth}px` : '0'
	}
	expandSelect() {
		gsap.fromTo(
			this.elOptionsWrapper,
			{
				maxWidth: 'none',
				width: 0,
			},
			{
				width: `${this.elOptions.scrollWidth}px`,
				duration: 0.3,
				ease: 'power4.out',
			},
		)

		this.isOpen = true
		this.elToggle.setAttribute('aria-expanded', this.isOpen)

		this.element.classList.add('is-expanded')
	}
	collapseSelect() {
		gsap.to(this.elOptionsWrapper, {
			width: 0,
			duration: 0.3,
			ease: 'power4.out',
			onComplete: () => {
				this.elOptionsWrapper.style.maxWidth = '0'
			},
		})

		this.isOpen = false
		this.elToggle.setAttribute('aria-expanded', this.isOpen)
		this.element.classList.remove('is-expanded')
	}
	init() {
		if (this.elToggle) {
			this.elToggle.addEventListener('click', this.handleToggleClick)
		}
	}
	destroy() {
		this.element.classList.remove('is-expanded')

		if (this.handleToggleClick) {
			this.elToggle.removeEventListener('click', this.handleToggleClick)
		}

		this.element = null
		this.elToggle = null
		this.elOptions = null
		this.elOptionsWrapper = null
	}
}
//
export default class extends Component {
	prepare() {
		this.languageSelect = new LanguageSelect(this.element)
	}

	mount() {}

	unmount() {
		if (this.languageSelect) {
			this.languageSelect.destroy()
			this.languageSelect = null
		}
	}
}
